import { buttonClassName } from '@emailforge/ui';
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--paper)',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', letterSpacing: 0.08 }}>
          404 · PAGE NOT FOUND
        </div>
        <h1 className="display" style={{ fontSize: 48, margin: '16px 0 12px' }}>
          Nothing to see <i style={{ color: 'var(--flame)' }}>here</i>
        </h1>
        <p style={{ color: 'var(--ink-2)', fontSize: 15, marginBottom: 24 }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={buttonClassName({ variant: 'primary' })}>
          Back to home
        </Link>
      </div>
    </div>
  );
}
